import { render, staticRenderFns } from "./LinkComp.vue?vue&type=template&id=41dfc636&"
import script from "./LinkComp.vue?vue&type=script&lang=js&"
export * from "./LinkComp.vue?vue&type=script&lang=js&"
import style0 from "./LinkComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports